import React from 'react'
import {  Container } from 'react-bootstrap'
import Cours from '../../../Utilitis/Course/Cours'
import Section from '../../../Utilitis/Section'
import TitleSection from '../../../Utilitis/TitleSection'
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

export default function PopularCourses(props) {

    return (
        <Section bg="white"   >
            <Container>
                <TitleSection text="Popular Courses" center title />
                <OwlCarousel className='owl-theme' {...props.option}  >
                    <div className='item'> <Cours name="1" title="Artificial intelligence Course" image="/images/course01.jpg" /></div>
                    <div className='item'> <Cours name="2" title="How to Get Started in Photography" image="/images/course02.jpg" /></div>
                    <div className='item'> <Cours name="3" title="Introduction to CSS" image="/images/course01.jpg" /></div>
                    <div className='item'> <Cours name="4" title="Artificial intelligence Course" image="/images/course04.jpg" /></div>
                    <div className='item'> <Cours name="5" title="Artificial intelligence Course" image="/images/course01.jpg" /></div>
                </OwlCarousel>;
            </Container>
        </Section>
    )
}
